import {Injectable} from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {environment} from "../../environments/environment";

@Injectable({
  providedIn: 'root'
})
export class ConfigurationsService {
  private data: Object;

  constructor(private http: HttpClient) {
  }

  loadConfigurations() {

    return this.http.get(environment.tourismBaseUrl+"uh/configurations").toPromise().then(r => {
      
      this.data = r;
    })
  }

  getConfigs() {
    return this.data;
  }

  getKey(key: string) {
    return (key in this.getConfigs()) ? this.getConfigs()[key] : null;
  }
}

